export default "__VITE_ASSET__221932f9__"